function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#CA3232",
  fillRule: "nonzero",
  d: "M231.313 39.687C205.72 14.095 171.693 0 135.5 0 99.307 0 65.28 14.095 39.687 39.687 14.094 65.28 0 99.307 0 135.5c0 36.193 14.094 70.22 39.687 95.813C65.28 256.905 99.307 271 135.5 271c36.193 0 70.22-14.095 95.813-39.687C256.906 205.72 271 171.693 271 135.5c0-36.193-14.094-70.22-39.687-95.813zM135.5 260C66.85 260 11 204.15 11 135.5S66.85 11 135.5 11 260 66.85 260 135.5 204.15 260 135.5 260z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 88.5,
  cy: 97.5,
  r: 12.5,
  fill: "#CA3232"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 183.5,
  cy: 97.5,
  r: 12.5,
  fill: "#CA3232"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#CA3232",
  strokeWidth: 10,
  d: "M83 188c35.285-33.333 70.285-33.333 105 0"
}));

function SvgSlowFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 271,
    height: 271,
    viewBox: "0 0 271 271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlowFace);
export default __webpack_public_path__ + "static/media/slow-face.09446d56.svg";
export { ForwardRef as ReactComponent };